/* global process */
/* eslint-disable react/jsx-closing-bracket-location */

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { hashHistory, IndexRedirect, Route, Router } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'

import {
    CHALLENGES,
    CLAN_LANDING,
    CLAN_MANAGEMENT,
    CLAN_LEAVING,
    SHOP_CONGRATULATIONS,
    SHOP_ERROR,
    SHOP_PRODUCT_PREVIEW,
    SHOP_STOREFRONT,
    SHOP_STUB,
    WGCWX_BATTLE_SCHEDULE,
    WGCWX_LEADERBOARDS,
} from 'urls'

import 'styles/style.scss'

import App from 'containers/App/App'
import AuthWrapper from 'containers/AuthWrapper/AuthWrapper'
import BuildingView from 'containers/BuildingView/BuildingView'
import BattleRooms from 'containers/BattleRooms/BattleRooms'
import UnitCreateWizard from 'containers/UnitCreateWizard/UnitCreateWizard'
import UnitRebuildWizard from 'containers/UnitRebuildWizard/UnitRebuildWizard'
import Construct from 'containers/Construct/Construct'
import PostBattleScreen from 'containers/PostbattleScreen/PostbattleScreen'
import Stronghold from 'containers/Stronghold/Stronghold'
import StrongholdWrapper from 'containers/StrongholdWrapper/StrongholdWrapper'
import UnitPreview from 'containers/BattleRooms/components/UnitPreview/UnitPreview'
import ClanLanding from 'containers/ClanLanding/ClanLandingContainer'
import ClanManagement from 'containers/ClanManagement/ClanManagement'
import ClanLeaving from 'containers/ClanLeaving/ClanLeaving'
import WGCWXWrapper from 'containers/WGCWXWrapper/WGCWXWrapper'
import WGCWXShop from 'containers/WGCWXShop/WGCWXShop'
import WGCWXBattleSchedule from 'containers/WGCWXBattleSchedule/WGCWXBattleSchedule'
import WGCWXLeaderboards from 'containers/WGCWXLeaderboards/WGCWXLeaderboards'
import Stub from 'containers/Stub/Stub'

import store from 'state/store'
import ShopView from '../containers/ShopView/ShopView'
import { hideTooltip } from 'helpers/web_to_client'

const history = syncHistoryWithStore(hashHistory, store)

require.context('../../app', true, /\.(png|jpe?g)$/)

if (process.env.NODE_ENV === 'production') {
    window.oncontextmenu = () => false
}

window.onBeforeUnloadHandlers = {}
window.onbeforeunload = () => {
    Object.values(window.onBeforeUnloadHandlers).forEach((handler) => {
        try {
            handler()
        } catch (e) {
            console.error(e) // eslint-disable-line no-console
        }
    })
}
window.onBeforeUnloadHandlers.hideTooltip = () => {
    // we wanna be ensure that all ingame tooltips became closed when we close interface @see WGCQ-573
    hideTooltip()
}

const loadShopProductPreviewScreen = (location, cb) =>
    require.ensure([], require => (
        cb(null, require('containers/ShopView/containers/ShopProductPreview/ShopProductPreview.jsx').default)
    ), 'ShopProductPreview')

const loadShopStorefrontScreen = (location, cb) =>
    require.ensure([], require => (
        cb(null, require('containers/ShopView/containers/ShopProductGrid/ShopProductGrid.jsx').default)
    ), 'ShopProductGrid')

const loadShopErrorScreen = (location, cb) =>
    require.ensure([], require => (
        cb(null, require('containers/ShopView/containers/ShopErrorScreen/ShopErrorScreen.jsx').default)
    ), 'ShopError')

const loadShopCongratulationScreen = (location, cb) =>
    require.ensure([], require => (
        // eslint-disable-next-line max-len
        cb(null, require('containers/ShopView/containers/ShopCongratulationScreen/ShopCongratulationScreen.jsx').default)
    ), 'ShopCongratulation')

const loadShopStubScreen = (location, cb) =>
    require.ensure([], require => (
        // eslint-disable-next-line max-len
        cb(null, require('containers/ShopView/containers/ShopStub/ShopStub.jsx').default)
    ), 'ShopStub')

ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <Route path='/' component={App}>
                <IndexRedirect to={CLAN_LANDING}/>
                <Route component={AuthWrapper}>
                    {/* todo: WGSH-3590 (fix it after 1.0.2 release) */}
                    <Route path='battlerooms' component={BattleRooms} />
                    {/* todo: WGSH-3590 (fix it after 1.0.2 release) */}
                    <Route path='units/create' component={UnitCreateWizard} />
                    {/* todo: WGSH-3590 (fix it after 1.0.2 release) */}
                    <Route path='units/rebuild/:unitServerId' component={UnitRebuildWizard} />
                    {/* todo: WGSH-3590 (fix it after 1.0.2 release) */}
                    <Route path='units/preview/:unitServerId' component={UnitPreview} />
                    <Route component={StrongholdWrapper}>
                        <Route path={CLAN_LANDING} component={ClanLanding} />
                        <Route path='stronghold' component={Stronghold}>
                            <Route path='build/:slotId' component={Construct} />
                            <Route path='building/:buildingId' component={BuildingView} />
                            <Route path='log' getComponent={(_, cb) => (
                                require.ensure([], require => (
                                    cb(null, require('containers/Journal/Journal.jsx').default)
                                ), 'log'))} />
                        </Route>
                        <Route path={CLAN_LEAVING} component={ClanLeaving} />
                        <Route path={CLAN_MANAGEMENT} component={ClanManagement}/>

                        <Route path='stronghold/leaderboard' getComponent={(_, cb) => (
                            require.ensure([], require => (
                                cb(null, require('containers/EloLeaderboard/EloLeaderboard.jsx').default)
                            ), 'leaderboard'))} />
                        <Route path='challenges-results/:challengeId' getComponent={(_, cb) => (
                            require.ensure([], require => (
                                cb(null, require('containers/ChallengesResults/ChallengesResults.jsx').default)
                            ), 'challenges-results'))} />
                        <Route path={`${CHALLENGES}(/:challengeId)`} getComponent={(location, cb) => (
                            require.ensure([], require => (
                                cb(null, require('containers/Challenges/Challenges.jsx').default)
                            ), 'challenges'))} />
                        <Route path={`${CHALLENGES}/:challengeId/:challengeName`} getComponent={(location, cb) => (
                            require.ensure([], require => (
                                cb(null, require('containers/ChallengeView/ChallengeView.jsx').default)
                            ), 'challenge'))} />
                        <Route component={ShopView}>
                            <Route path={SHOP_PRODUCT_PREVIEW()} getComponent={loadShopProductPreviewScreen}/>
                            <Route path={SHOP_ERROR()} getComponent={loadShopErrorScreen}/>
                            <Route path={SHOP_STOREFRONT} getComponent={loadShopStorefrontScreen}/>
                            <Route path={SHOP_CONGRATULATIONS()} getComponent={loadShopCongratulationScreen}/>
                            <Route path={SHOP_STUB()} getComponent={loadShopStubScreen}/>
                        </Route>
                    </Route>
                </Route>
                {/* WGSH-3590 */}
                <Route path='postbattle/:seriesId/:clanId' component={PostBattleScreen}/>
                <Route path='stronghold/:clanId' component={Stronghold} />
                <Route component={WGCWXWrapper}>
                    <Route path='personal_shop/:partitionType' component={WGCWXShop} />
                    <Route path={WGCWX_BATTLE_SCHEDULE} component={WGCWXBattleSchedule} />
                    <Route path={WGCWX_LEADERBOARDS} component={WGCWXLeaderboards} />
                </Route>
                <Route path='stub' component={Stub} />
            </Route>
        </Router>
    </Provider>,
    document.getElementById('content')
)



// WEBPACK FOOTER //
// ./entry_points/index.js